<template>
  <div class="popup-wrap active">
    <div class="popup-box mx-395">
      <a class="popup-close" @click="$emit('close')"><i class="fa-solid fa-xmark" /></a>
      <div class="form-popup popup-padding">
        <div class="popup-envelop">
          <div class="content">
            <p>{{ $t('Bao.is_handle_deposit') }}</p>
          </div>
          <div class="form-button form-ft">
            <button class="btn-primary" @click="$emit('submit')">
              <span>{{ $t('Bao.submit') }}</span>
            </button>
            <button class="btn-primary" @click="$emit('close')">
              <span>{{ $t('Bao.cancel') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FirstDepositModal',
  mounted() {
    const target = this.$el.closest('main') || document.body
    target.appendChild(this.$el)
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>
